// Imports => React
import { useState, useEffect, useMemo, memo } from 'react';
import { withStore } from '@stores';
import { observer } from 'mobx-react-lite';
import queryString from 'query-string-es5';
import clsx from 'clsx';

// Imports => Constants
import { TITLES } from '@constants';
import {
  KEYS,
  PERMISSIONS,
  ROLES,
  THEMES,
  TYPES,
} from '@opp/ui-kit';

// Imports => Utilities
import {
  AcIsSet,
  AcIsArray,
  AcIsUndefined,
} from '@opp/ui-kit';

// Imports => Hooks
import { useOverviewActions } from '@hooks';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcLoaderInline,
  AcEmptyBlock,
  AcPagination,
} from '@opp/ui-kit';
import AcPurchaseList from '@components/ac-purchase-list/ac-purchase-list';
import {AcGetPaginationTranslations} from "../../../utilities/ac-translate-consts";
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-purchases-overview-all-tab',
};

const AcPurchasesOverviewAllTab = ({ data, store: { purchases }, t }) => {
  const { current_purchases, current_meta, is_loading } = purchases;

  const handlePagination = (event, num) => {
    const $scroller = document.querySelector('#ac-scroller');
    if ($scroller) $scroller.scrollTop = 0;

    if (AcIsSet(num)) purchases.setPageNumber(num);
    purchases.list(t, {
      order: '-date',
      date_start: '01-01-2000',
    });
  };

  useEffect(() => {
    const parsed = queryString.parse(window.location.search);
    purchases.reset(KEYS.PURCHASE);
    purchases.reset(KEYS.PURCHASES);

    const options = {
      order: '-date',
      date_start: '01-01-2000',
      expand: [
        'order.orderProducts',
        'escrow',
      ],
    };

    if (AcIsSet(parsed) && AcIsSet(parsed.page)) {
      purchases.setPageNumber(parsed.page);
    } else {
      purchases.setPageNumber(1);
    }

    purchases.list(t, options);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  });

  const renderPurchases = useMemo(() => {
    if (is_loading) return <AcLoaderInline loading />;

    if (
      !AcIsSet(current_purchases) ||
            !AcIsArray(current_purchases) ||
            current_purchases.length === 0
    ) {
      return <AcEmptyBlock message={'No purchases found to display'} />;
    }

    return <AcPurchaseList items={current_purchases} />;
  }, [current_purchases, is_loading]);

  const renderPagination = useMemo(() => {
    if (is_loading) return null;

    if (
      !AcIsSet(current_purchases) ||
            !AcIsArray(current_purchases) ||
            current_purchases.length === 0
    )
      return null;

    const options = {
      current_page: current_meta.current_page,
      last_page: current_meta.last_page,
      total_count: current_meta.total,
      total_pages: Math.ceil(current_meta.total / current_meta.per_page),
      per_page: current_meta.per_page,
      callback: handlePagination,
      from: current_meta.from,
      to: current_meta.to,
      showFromTo: true,
    };

    return <AcPagination
      translations={AcGetPaginationTranslations(t)}
      {...options} />;
  }, [current_purchases, current_meta, is_loading]);

  return (
    <div className={getMainClassNames}>
      <AcContainer fluid>
        <AcRow>
          <AcColumn xs={12}>{renderPurchases}</AcColumn>
        </AcRow>

        <AcRow className={'h-padding-bottom-50'}>
          <AcColumn xs={12}>{renderPagination}</AcColumn>
        </AcRow>
      </AcContainer>
    </div>
  );
};

export default withTranslation(['pagination', 'store'])(withStore(observer(AcPurchasesOverviewAllTab)));
